// 环境 -> 配置档位（profile）映射
// mode 对应的是构建时的 Vite 模式（即 `vite --mode xxx` 中的 xxx）
// profile 对应的是 src/configs/<profile> 目录下的一套路由和功能配置

export const MODE_TO_PROFILE = {
  dtest: 'dtest',
  piccdl: 'piccdl',
  'kbt-map': 'kbt-map',
  report: 'report',
  'wx-webview': 'wx-webview',

  // 这些环境共用 standard 这套配置
  kbt: 'standard',
  cic: 'standard',
  boc: 'standard',
  tian: 'tian',
  zsins: 'standard',
  taiping: 'standard',
  'chinalife-p': 'standard',
  zking: 'standard',
  ccic: 'standard',
  gstest: 'standard',
  chgic: 'standard',
  cyberport: 'standard',
  bjbf: 'standard',
} as const

export type ProfileMode = keyof typeof MODE_TO_PROFILE
export type ProfileName = (typeof MODE_TO_PROFILE)[ProfileMode]

export function resolveProfileName(mode: string): ProfileName {
  if (!(mode in MODE_TO_PROFILE)) {
    throw new Error(`Profile for mode "${mode}" not found. Run Vite with --mode <profile>.`)
  }

  const profileName = MODE_TO_PROFILE[mode as ProfileMode]

  return profileName
}
